module.exports = __webpack_public_path__ + "static/media/pwa.9a4695e6.png";